import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=6365a686&scoped=true&"
import script from "./FileUpload.vue?vue&type=script&lang=js&"
export * from "./FileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365a686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6365a686')) {
      api.createRecord('6365a686', component.options)
    } else {
      api.reload('6365a686', component.options)
    }
    module.hot.accept("./FileUpload.vue?vue&type=template&id=6365a686&scoped=true&", function () {
      api.rerender('6365a686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Ui/FileUpload.vue"
export default component.exports